import { useSubscription } from '../context/SubscriptionContext';
import { useLocation, Link } from 'react-router-dom';
import Layout from './Layout';
import { Lock } from 'lucide-react';
import { Button } from './ui/button';

const READ_ONLY_PATHS = ['/dashboard'];

export default function SubscriptionGate({ children }) {
  const { subscription, loading } = useSubscription();
  const location = useLocation();

  if (loading) return children;
  if (!subscription) return children;

  if (subscription.is_active) return children;

  // Expired: allow read-only dashboard, block everything else
  const isReadOnlyAllowed = READ_ONLY_PATHS.some(p => location.pathname.startsWith(p));

  if (isReadOnlyAllowed) return children;

  return (
    <Layout title="Upgrade Required">
      <div className="flex flex-col items-center justify-center py-20 text-center" data-testid="paywall-gate">
        <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6" style={{ background: 'rgba(198,156,109,0.1)' }}>
          <Lock size={28} style={{ color: '#D98A4A' }} />
        </div>
        <h2 className="font-heading text-3xl font-medium mb-3" style={{ color: '#1A1A1A' }}>
          <span className="italic" style={{ color: '#D98A4A' }}>Upgrade</span> to Access
        </h2>
        <p className="font-body text-sm max-w-md mb-8" style={{ color: '#4B5563' }}>
          Your free trial has ended. Upgrade to a paid plan to unlock all features including transactions, 
          financial statements, reconciliation, and more.
        </p>
        <Link to="/pricing">
          <Button className="h-12 px-8 rounded-full font-body font-medium text-white" style={{ background: '#0A3622' }} data-testid="upgrade-paywall-btn">
            View Plans & Upgrade
          </Button>
        </Link>
        <Link to="/dashboard" className="mt-4 font-body text-sm hover:underline" style={{ color: '#9CA3AF' }}>
          Back to Dashboard (read-only)
        </Link>
      </div>
    </Layout>
  );
}
